import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

/* Academy thin-line profile photo nudge — sits BELOW the photo cards,
   never above the hero. Gone for good once the user has a photo. */
export const ProfilePhotoCard = () => {
  const { user } = useAuth();
  if (!user || user.picture || user.is_demo || ['founder', 'super_admin'].includes(user.role)) return null;
  return (
    <div className="bg-white border border-[#E8DDD5] rounded-[18px] p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 mb-6"
      data-testid="profile-photo-card">
      <div className="flex-1 min-w-0">
        <h3 className="text-xl text-[#2B1F27] leading-snug" style={{ fontFamily: "'Bodoni Moda', Georgia, serif", fontWeight: 500 }}>
          Add your photo
        </h3>
        <p className="text-sm text-[#64525D] mt-1">A photo on your profile helps everyone know who they are talking to.</p>
      </div>
      <Link to="/dashboard/profile" className="rvk-pill on shrink-0 no-underline" data-testid="profile-photo-card-upload">
        Upload photo
      </Link>
    </div>
  );
};
